// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import styles from "./scss/main.scss"
import VueAnalytics from "vue-analytics"
import VuexForms from "vuex-forms"

Vue.use(VueAnalytics, {
    id: 'UA-100999435-1',
    router
})
Vue.use(VuexForms)

Vue.config.productionTip = false

import SvgRenderer   from "./components/shared/SvgRenderer.vue";
import Affix         from "./components/shared/Affix.vue";
import TextInput     from "./components/shared/TextInput.vue";
import PortfolioItem from "./components/shared/PortfolioItem";
Vue.component('svg-renderer', SvgRenderer)
Vue.component('affix', Affix)
Vue.component('text-input', TextInput)
Vue.component('portfolio-item', PortfolioItem)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js